import Vue from "vue";
import VueRouter from "vue-router";
import Paid from "../views/Paid.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/Paid",
    name: "Paid",
    component: Paid
  },
];

const router = new VueRouter({
  routes,
});

export default router;
